export function routerReplace(router, options) {
  if (typeof options == "string") {
    let nextPath = router.currentRoute.fullPath.toLowerCase();
    if (router.currentRoute.fullPath !== nextPath)
      router.replace(nextPath);

  } else {
    const { path, query } = options;

    let eqal = false;
    if (router.history.current.path === path) {
      let jsonNewQuery = JSON.stringify(query);
      let jsonQuery = JSON.stringify(router.history.current.query);
      if (jsonNewQuery === jsonQuery)
        eqal = true;
    }

    if (!eqal) router.replace({ path, query });
  }
}
